import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { LoaderService } from '../../helpers/loader.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loader.component.scss',
})
export class LoaderComponent implements OnInit {
  isLoading$: Observable<boolean>; // Use observable directly in template with async pipe

  constructor(private loaderService: LoaderService) {
    this.isLoading$ = this.loaderService.isLoading$; // Assign the observable
  }

  ngOnInit(): void {
    // No manual subscription needed here if using async pipe in template
  }
}
